module.exports = __webpack_public_path__ + "0ef7d070fb1ee2fd4d528628af30c473.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/diamond-shapes/images/emerald@2x.png
// module id = 305
// module chunks = 0